"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValue = exports.convertObjectKeysToCamelCase = void 0;
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
/**
 * @method convertObjectKeysToCamelCase
 * @param srcObject
 * @returns object having keys in camelCase
 */
function convertObjectKeysToCamelCase(srcObject) {
    const camelCaseObject = {};
    const srcObjectKeys = Object.keys(srcObject);
    srcObjectKeys.forEach((key) => {
        camelCaseObject[(0, lodash_camelcase_1.default)(key)] = srcObject[key];
    });
    return camelCaseObject;
}
exports.convertObjectKeysToCamelCase = convertObjectKeysToCamelCase;
function setValue(value, defaultValue) {
    let newValue = value;
    if (!value) {
        newValue = defaultValue;
    }
    return newValue;
}
exports.setValue = setValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL29iamVjdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7Ozs7O0dBTUc7QUFDSCx3RUFBeUM7QUFFekM7Ozs7R0FJRztBQUNILFNBQWdCLDRCQUE0QixDQUFDLFNBQThCO0lBQ3pFLE1BQU0sZUFBZSxHQUF3QixFQUFFLENBQUM7SUFDaEQsTUFBTSxhQUFhLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUM3QyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUMsR0FBVyxFQUFFLEVBQUU7UUFDcEMsZUFBZSxDQUFDLElBQUEsMEJBQVMsRUFBQyxHQUFHLENBQVcsQ0FBQyxHQUFHLFNBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUM3RCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sZUFBZSxDQUFDO0FBQ3pCLENBQUM7QUFQRCxvRUFPQztBQUVELFNBQWdCLFFBQVEsQ0FBQyxLQUEwQixFQUFFLFlBQXFCO0lBQ3hFLElBQUksUUFBUSxHQUFHLEtBQUssQ0FBQztJQUVyQixJQUFJLENBQUMsS0FBSyxFQUFFO1FBQ1YsUUFBUSxHQUFHLFlBQVksQ0FBQztLQUN6QjtJQUNELE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUM7QUFQRCw0QkFPQyJ9